import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[component-forms]'
})
export class ComponentFormsDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
